import React from "react";
import Table from "../../Common/Table";
import { useHistory } from "react-router-dom";

import TableFields from "../../../constants/City/TableFields.json";
import Permission from "../../Common/Permission";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import { Pill } from "../../../constants/assets/containers";
import { getPath } from "../../../utils";

const CityList = (props) => {
  const history = useHistory();
  const { cityList } = props;
  const allActions = MenuActionsMappings[MenuNames.CITY];

  const getFieldValue = (city, key) => {
    switch (key) {
      case "actions":
        return (
          <Permission
            optionalPerms={[allActions.UPDATE, allActions.DETAIL]}
            notAllowedText="No Allowed Actions"
          >
            <span
              onClick={() => history.push(`/cities/${city.id}`)}
              className={"edit-options cursor-pointer"}
            >
              View/Edit
            </span>
          </Permission>
        );
      case "city_supported":
        return <Pill isFalse={!city[key]}>{city[key] ? "Yes" : "No"}</Pill>;
      default:
        return getPath(city, key, "NA");
    }
  };

  return (
    <Table list={cityList} getFieldValue={getFieldValue} fields={TableFields} />
  );
};

export default CityList;
